import React, { useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "./Navbar/Navbar.js";
//import home from '../Images/home.jpg';
import home from "../Images/homeLite.jpg";
import WhoWeAre from "./WhoWeAre/WhoWeAre.js";
import WhatWeDo from "./WhatWeDo/WhatWeDo.js";
import ContactUs from "./Contact/ContactUs.js";
import Footerpage from "./Footer/Footer.js";
import TechStack from "./Techstack/Techstack.js";
import Career from "./Career/Career.js";
import Typed from "typed.js";
import { useLocation, useNavigate } from "react-router-dom";
import OurServices from "./OurServices/OurServices.js";
import Slider from "./WhatWeDo/components/Slider.js"
import Scroller from "./WhatWeDo/components/Scroller.js";
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-100 z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const Container = styled.div`
  ${tw`relative h-screen bg-cover bg-black`}
  /* background-image: url(${home}); */
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const TwoColumn = styled.div((props) => [
  props.containerPdf
    ? tw.div` pb-32 px-16 flex justify-between items-center flex-col lg:flex-row`
    : tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`,
]);
const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const HighlightedText = tw.span`bg-gray-100 text-primary-500 px-4 pb-2 inline-block`;
const LogoContainer = tw.div`flex lg:justify-end absolute z-1 w-full`;

const LogoText = tw.h5`ml-0 text-6xl pt-10 text-indigo-600 font-bold `;
const Notification = tw.span`inline-block my-4 pl-3 py-1 mt-48 text-gray-100 border-blue-800 font-medium text-lg border-l-4`;

const TypedString = tw.span``;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 font-bold rounded bg-primary-500 text-gray-100
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0`;

function elementExistsById(id) {
  return !!document.getElementById(id);
}

const scrollToHome = () => {
  if (
    window.pageYOffset === 0 &&
    elementExistsById("header") &&
    elementExistsById("logoFontFamily")
  ) {
    document.getElementById("header").classList.remove("navbarStyle");
    document.getElementById("logoFontFamily").classList.remove("navbarLogo");
  }
};
const Home = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(()=>{
    document.title="Welcome to Iqura"
    let descMeta=document.querySelector("meta[name='description']")
    descMeta.setAttribute("content", 'Iqura corporate website')
    let keyword=document.querySelector("meta[name='keywords']")
    keyword.setAttribute("content", "Real Estate Software Development, Cloud Consulting  & Services, Digital Transformation Services, Application, API Development, Application  Maintenance & Support, Third-Party API Integrations, Dedicated  Development Teams and Product Engineering")
    },[]);
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    if (location.state) {
      let element = document.getElementById(location.state);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
        });
        navigate(location.pathname, { replace: true });
      }
    }
  }, [location]);

  // useEffect(() => {
  //   var typed = new Typed("#element", {
  //     strings: [
  //       "Bespoke software development company ",
  //       "Reliable, experienced and cost-effective team",
  //     ],
  //     typeSpeed: 50,
  //     backSpeed: 50,
  //     loop: true,
  //   });
  //   return () => {
  //     typed.destroy();
  //   };
  // }, []);

  const scrollToWhoWeAre = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("whoweare").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const scrollToOurServices = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("ourservices").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const scrollToWhatWeDo = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("whatwedo").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const scrollToTechstack = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("techstack").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const scrollToCareer = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("career").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const scrollToContactUs = () => {
    document.getElementById("header").classList.add("navbarStyle");
    document.getElementById("contact").scrollIntoView({
      behaviour: "smooth",
    });
    window.addEventListener("scroll", scrollToHome);
    document.getElementById("logoFontFamily").classList.add("navbarLogo");
  };

  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => scrollToWhatWeDo()}>What we do</NavLink>
      <NavLink onClick={() => scrollToOurServices()}>Services</NavLink>
      <NavLink onClick={() => scrollToTechstack()}>Techstack</NavLink>
      <NavLink onClick={() => scrollToWhoWeAre()}>Who we are</NavLink>
      <NavLink onClick={() => scrollToCareer()}>Careers</NavLink>
      <NavLink onClick={() => scrollToContactUs()}>Contact</NavLink>
    </NavLinks>,
  ];

  return (
    <>
      <Container id="navbar">

        {/* <OpacityOverlay />
        */}
        {props.home === "pdf" && (
            <LogoContainer className={props.home === "pdf" && "mr-16 "}>
              <div className="flex lg:justify-end w-full mr-16 ">
              <LogoText className="logoFontFamily">Iqura</LogoText>
              </div>
         
            </LogoContainer>
          )}
          {props.home !== "pdf" && <StyledHeader links={navLinks} />}
          {/* <StyledHeader links={navLinks} /> */}
{/* 
          <TwoColumn containerPdf={props.home === "pdf"}>
            <LeftColumn className={props.home === "pdf" && "px-16"}>
              <Notification>
                <TypedString id="element"></TypedString>
              </Notification>
              <Heading>
                <span>Hire the best</span>
                <br />
                <HighlightedText className="transform -skew-x-12">
                  Development Team.
                </HighlightedText>
              </Heading>
              <PrimaryAction onClick={() => scrollToContactUs()}>
                Hire Us
              </PrimaryAction>
            </LeftColumn>
          </TwoColumn> */}
          <Slider/>
      
      </Container>
      {props.home !== "pdf" && (
        <>
          <WhatWeDo id="whatwedo" />
          <OurServices id="ourservices"/>
          <Scroller/>
          <TechStack id="techstack" />
          <WhoWeAre id="whoweare" />
          <Career id="career" />
          <ContactUs id="contact" />
          <Footerpage />
        </>
      )}
    </>
  );
};

export default Home;
